import { render, staticRenderFns } from "./VehicleSourcePriceInformationField.vue?vue&type=template&id=90dbbc46&scoped=true"
import script from "./VehicleSourcePriceInformationField.vue?vue&type=script&lang=ts"
export * from "./VehicleSourcePriceInformationField.vue?vue&type=script&lang=ts"
import style0 from "./VehicleSourcePriceInformationField.vue?vue&type=style&index=0&id=90dbbc46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dbbc46",
  null
  
)

export default component.exports